export default {
  component: () => import('./page.vue'),
  path: '/family/:familyId',
  name: 'family',
  meta: {
    title: '家庭组详情',
    auth: true,
  },
};
